export const SmoothScrollModule = angular
    .module('app.directives.smoothScroll', [])
    .directive('smoothScroll', ($window, $document) => {
        return {
            link: (scope, el, attrs) => {
                el.on('click', () => {
                    var location = attrs.smoothScroll;
                    var $$window = angular.element($window);
                    var $$document = angular.element($document);
                    var $pageStatus = angular.element('.page__status');
                    var $pageHeader = angular.element('.page__header');
                    var start;
                    var lastTime;
                    var offset;
                    var scrollTo;
                    var maxScroll;

                    if (!location) {
                        throw new Error('No Scroll location given!');
                    }

                    var scrollEl = angular.element(`#${location}`);

                    if (scrollEl) {
                        var headerHeight = $pageHeader.is(':visible') ? $pageHeader.height() : 0;
                        var statusHeight = $pageStatus.is(':visible') ? $pageStatus.height() : 0;

                        maxScroll = $$document.height() - $$window.height();
                        offset = angular.element($window).scrollTop();
                        scrollTo = scrollEl.offset().top - headerHeight - statusHeight;
                        scrollTo = maxScroll < scrollTo ? maxScroll : scrollTo;
                        start = false;

                        $window.requestAnimationFrame(scroll);
                    }

                    function scroll(time) {
                        if (!start) {
                            lastTime = time;
                        }

                        var deltaTime = time - lastTime;
                        $window.scroll(0, lerp(offset, scrollTo, 0.3 * (deltaTime / 60)));
                        var oldOffset = offset;
                        offset = angular.element($window).scrollTop();
                        lastTime = time;

                        if (scrollTo - offset > 0
                                && (offset !== maxScroll || oldOffset !== offset || start === false)) {
                            start = true;
                            $window.requestAnimationFrame(scroll);
                        }
                    }

                    function lerp(from, to, time) {
                        return Math.ceil(from + (time * (to - from)));
                    }
                });
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/smoothScroll.directive.js